// Shared customer-grade (traffic-light rating) display labels.
// Lao uses plain color words per field-team convention (V17.284):
// green = ຂຽວ, yellow = ເຫຼືອງ, red = ແດງ.
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import type { Language } from '../contexts/LanguageContext';

export type Rating = 'green' | 'yellow' | 'red';

export const RATING_LABELS: Record<Language, Record<Rating, string>> = {
  lo: { green: 'ຂຽວ', yellow: 'ເຫຼືອງ', red: 'ແດງ' },
  en: { green: 'green', yellow: 'yellow', red: 'red' },
};

export function ratingLabel(r: Rating, language: Language): string {
  return RATING_LABELS[language]?.[r] ?? r;
}

// Provider-optional variant of useLanguage for leaf display components:
// falls back to the app default ('lo') instead of throwing when rendered
// outside LanguageProvider (e.g. standalone component tests).
export function useRatingLanguage(): Language {
  return useContext(LanguageContext)?.language ?? 'lo';
}
